import styled from 'styled-components'

export const LeftContainer = styled.div`
  min-width: 400px;
  flex: 2;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  min-height: calc(100% + 5px);
`

export const CenterContainer = styled.div`
  padding-top: 40px;
  flex: auto;
  height: 100%;
  width: 100%;
`

export const RightContainer = styled.div`
  padding-top: 40px;
  max-width: 280px;
  /* flex: 1; */
  width: 100%;
  height: 100%;
`

export const StrongTitle = styled.strong`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.ds.typography.size.small};
  line-height: 28px;
  margin-right: 20px;
`

export const StrongLabel = styled.strong`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  line-height: 28px;
  margin-right: 20px;
  margin-top: 20px;
`

export const SubTitle = styled.label`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.bold};
  line-height: 28px;
`

export const TextDescription = styled.span`
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.font.normal};
  /* margin-bottom: 20px; */
`

export const TitleEligibility = styled.p<any>`
  color: ${({ theme, color }) => color || theme.ds.colors.primary600};
  font-weight: ${({ theme }) => theme.font.semiBold};
  margin-bottom: 5px;
  display: flex;
  place-content: center;
  align-items: center;
  gap: 4px;

  svg {
    path {
      fill: ${({ theme, color }) => color || theme.ds.colors.primary600};
    }
  }
`

export const TextStrong = styled.p`
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.font.semiBold};
  /* margin-bottom: 20px; */
`

export const TextLight = styled.p`
  color: ${({ theme }) => theme.ds.colors.neutral800};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.font.semiBold};
  margin-top: 20px;
`

export const RadioContainer = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 30px;
`

export const Separator = styled.div`
  width: 1px;
  height: 572px;
  margin: 0 18px;
  background-color: ${({ theme }) => theme.ds.colors.neutral100};
  justify-self: flex-end;
  align-self: flex-end;
`

export const PatientControlPanel = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const ManualStatusInfo = styled.p`
  color: ${({ theme }) => theme.ds.colors.neutral600};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
  margin-bottom: 10px;
`

export const ButtonContainer = styled.p`
  margin: 25px 0;
`

export const Ball = styled.div<any>`
  border-radius: 10px;
  background: ${({ theme, colorBall }) =>
    colorBall || theme.ds.colors.primary600};
  width: 18px;
  height: 18px;
  color: ${({ theme }) => theme.ds.colors.primary600};
`

export const AuthorizationStatusContainer = styled.div`
  /* display: flex; */
  align-items: center;
  gap: 7px;
  margin-bottom: 20px;
  margin-top: 5px;
  span {
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    color: ${({ theme }) => theme.ds.colors.neutral700};
  }
`

export const SingleStatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 20px;
  margin-top: 5px;
  span {
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    color: ${({ theme }) => theme.ds.colors.neutral700};
  }
`

export const AuthorizationStatusBlock = styled.div`
  display: flex;
  flex-direction: column;

  gap: 7px;
  margin-bottom: 20px;
  label {
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    color: ${({ theme }) => theme.ds.colors.neutral700};
  }
  span {
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    color: ${({ theme }) => theme.ds.colors.neutral700};
  }

  h4 {
    color: ${({ theme }) => theme.ds.colors.neutral700};
  }
`

export const ButtonPanel = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 25px;
`

export const ModalButtonPanel = styled.form`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  align-items: center;
  gap: 20px;
  width: auto;
  margin-bottom: 10px;
`

export const FlexButtonPanel = styled.div`
  display: flex;
  justify-content: end;
  margin-left: auto;
  gap: 40px;
`

export const ModalInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const Title = styled.h3`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const AccommodationSwitch = styled.div`
  display: flex;
  gap: 8px;
  margin: 'auto';
  place-content: center;
  cursor: pointer;
`

export const ContainerTimeline = styled.ul`
  display: flex;
  flex-direction: column;

  strong {
    font-size: ${({ theme }) => theme.font.sizes.small};
    font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
    color: ${({ theme }) => theme.ds.colors.neutral700};
    line-height: 20px;
  }

  span {
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
    margin-bottom: 5px;
  }

  p {
    font-size: ${({ theme }) => theme.font.sizes.small};
  }
`

export const ItemList = styled.li<any>`
  list-style: none;
  margin-left: 10px;
  padding: 0px 10px 20px 15px;
  position: relative;
  display: flex;
  flex-direction: column;
  border-left: 2px solid ${({ theme }) => theme.ds.colors.neutral400};

  &:last-child {
    border-left: none;
    left: 2px;
  }

  &::before {
    position: absolute;
    left: -11px;
    content: ' ';
    border-radius: 500%;
    background: ${({ theme }) => theme.ds.colors.neutral400};
    height: 20px;
    width: 20px;
    transition: all 500ms ease-in-out;
  }

  &:first-child:before {
    background: ${({ colorBall }) => colorBall};
  }
`

export const StyledIcon = styled.div`
  display: flex;

  svg {
    margin-right: 5px;
    path {
      fill: none !important;
      stroke: ${({ theme }) => theme.ds.colors.primary600};
    }

    &:hover {
      stroke: ${({ theme }) => theme.ds.colors.primary500};
    }

    &:active {
      stroke: ${({ theme }) => theme.ds.colors.primary700};
    }
  }
`
